import { render, staticRenderFns } from "./product-support.vue?vue&type=template&id=741ef1a6"
import script from "./product-support.vue?vue&type=script&lang=js"
export * from "./product-support.vue?vue&type=script&lang=js"
import style0 from "./product-support.vue?vue&type=style&index=0&id=741ef1a6&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports